import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { getUser } from 'src/common/utils/reduxStoreSelectors';
import Avatar from '../Avatar';
import style from './Navigation.module.scss';

const SubNavUserDetails: FC = () => {
  const user = useSelector(getUser).toJS();

  return (
    <div className={style.avatar}>
      <Avatar
        classNameModifier="noMargin"
        user={user}
      />
      <span>
        {user?.first_name}
        {' '}
        {user?.last_name}
      </span>
    </div>
  );
};

export default SubNavUserDetails;
